import http from "./httpService";
import urlConstant from "../constants/url-constants";

export async function RegisterComplaint(name, mobile, phone, complaint, userId) {
    const { data: result } = await http.post(urlConstant.getCustomerAddComplaintEndpoint(), {
        name,
        mobile,
        phone,
        complaint,
        userId
    }, http.getAuthorizedConfig());
    return result;
}

export async function ComplaintsList(userId) {
    const { data: result } = await http.post(urlConstant.getCustomerComplaintListEndpoint(), {
        userId
    }, http.getAuthorizedConfig());
    return result;
}

export default {
    RegisterComplaint, ComplaintsList
};

